var exports = {
  "jD": "xaee3c4fa--aa0087--breadcrumbs",
  "Il": "xaee3c4fa--aa0087--breadcrumbs__item",
  "bI": "xaee3c4fa--aa0087--breadcrumbs__link",
  "c1": "xaee3c4fa--aa0087--breadcrumbs__item-empty",
  "uF": "xaee3c4fa--aa0087--breadcrumbs-mobile",
  "K_": "xaee3c4fa--aa0087--breadcrumbs-dekstop",
  "_8": "xaee3c4fa--aa0087--breadcrumbs-hidden",
};

module.exports = exports;
